import { ComponentType } from 'react';
import DateTime, { DatetimepickerProps } from 'react-datetime';

// Because renderInput prop is missing in type definition
// https://github.com/YouCanBookMe/react-datetime/pull/541
type RenderInput = {
  renderInput?: (
    props: any,
    openCalendar: () => void,
    closeCalendar: () => void,
  ) => void;
};

export type ReactDateTime = DatetimepickerProps & RenderInput;

export const ReactDateTimeComponent = DateTime as ComponentType<ReactDateTime>;
